module.exports = __webpack_public_path__ + "img/mercedes-eqc-page-gal-4.6a871f14.jpg";